// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { PropsWithChildren } from 'https://esm.sh/react@18';

type LayoutInternalProps = {
  logo: string;
  appName: string;
  appUrl: string;
};
export function LayoutInternal({ children, logo, appName, appUrl }: PropsWithChildren<LayoutInternalProps>) {
  return (
    <div
      style={{
        backgroundColor: '#EEEEEE',
        padding: '32px 0px',
        color: '#242424',
      }}
    >
      <table
        align="center"
        width="100%"
        style={{
          boxSizing: 'inherit',
          backgroundColor: '#FFFFFF',
          maxWidth: '600px',
          minHeight: '48px',
        }}
        role="presentation"
        cellSpacing="0"
        cellPadding="0"
        border={0}
        bgcolor="#FFFFFF"
      >
        <tbody
          style={{
            boxSizing: 'inherit',
          }}
        >
          <tr
            style={{
              boxSizing: 'inherit',
              width: '100%',
            }}
          >
            <td
              style={{
                boxSizing: 'inherit',
              }}
            >
              <div
                style={{
                  fontFamily: 'inherit',
                  fontSize: '16px',
                  fontWeight: 'normal',
                  padding: '24px 24px 0px 24px',
                  textAlign: 'left',
                  maxWidth: '100%',
                  boxSizing: 'border-box',
                }}
              >
                <div
                  style={{
                    boxSizing: 'inherit',
                  }}
                >
                  <table
                    align="center"
                    width="100%"
                    cellPadding="0"
                    border={0}
                    style={{
                      boxSizing: 'inherit',
                      tableLayout: 'fixed',
                      borderCollapse: 'collapse',
                    }}
                  >
                    <tbody
                      style={{
                        boxSizing: 'inherit',
                        width: '100%',
                      }}
                    >
                      <tr
                        style={{
                          boxSizing: 'inherit',
                          width: '100%',
                        }}
                      >
                        <td
                          style={{
                            boxSizing: 'content-box',
                            verticalAlign: 'middle',
                            textAlign: 'left',
                            width: '50%',
                            paddingLeft: 0,
                            paddingRight: '8px',
                          }}
                          width="50%"
                          valign="middle"
                          align="left"
                        >
                          <div
                            style={{
                              fontFamily: 'inherit',
                              fontSize: '16px',
                              fontWeight: 'normal',
                              padding: '0px 0px 0px 0px',
                              textAlign: 'left',
                              maxWidth: '100%',
                              boxSizing: 'border-box',
                            }}
                          >
                            <div
                              style={{
                                padding: '0px 0px 0px 0px',
                                textAlign: 'center',
                                maxWidth: '100%',
                                boxSizing: 'border-box',
                              }}
                            >
                              <a href={appUrl}>
                                <img
                                  src={logo}
                                  alt="logo"
                                  style={{
                                    maxWidth: '370px',
                                    maxHeight: '150px',
                                    margin: '0px auto',
                                  }}
                                />
                              </a>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div
                style={{
                  padding: '24px',
                }}
              >
                {children}
              </div>

              <div
                style={{
                  maxWidth: '100%',
                  boxSizing: 'border-box',
                }}
              >
                <hr
                  style={{
                    boxSizing: 'inherit',
                    margin: '0px',
                    width: '100%',
                    border: 'none',
                    borderTop: '1px solid #eaeaea',
                    borderColor: 'rgb(233, 233, 233)',
                    borderTopWidth: '1px',
                  }}
                />
              </div>
              <div
                style={{
                  color: '#474849',
                  fontFamily: 'inherit',
                  fontSize: '12px',
                  fontWeight: 'normal',
                  padding: '24px 24px 24px 24px',
                  textAlign: 'center',
                  maxWidth: '100%',
                  boxSizing: 'border-box',
                }}
              >
                <div
                  style={{
                    boxSizing: 'inherit',
                  }}
                >
                  <div
                    style={{
                      boxSizing: 'inherit',
                    }}
                  >
                    <p
                      style={{
                        boxSizing: 'inherit',
                        marginTop: '0px',
                        marginBottom: '0px',
                      }}
                    >
                      {appName} © {new Date().getFullYear()}
                    </p>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

function Layout({ children }: PropsWithChildren) {
  return (
    <LayoutInternal
      appName={Deno.env.get('APP_NAME') ?? ''}
      appUrl={Deno.env.get('FRONTEND_APP_URL') ?? ''}
      logo={`${Deno.env.get('FRONTEND_APP_URL')}/assets/logoPng.png`}
    >
      {children}
    </LayoutInternal>
  );
}

export default Layout;
